const Report = () =>
  import(
    /* webpackChunkName: "driver-blackList" */ '@/pages/transport/black-list/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "driver-blackList" */ '@/pages/transport/black-list/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "driver-blackList" */ '@/pages/transport/black-list/edit.vue'
  )

export default {
  path: 'blackList',
  meta: {
    label: 'blackList',
    auth: 'driverBlackList'
  },
  component: {
    name: 'Driver',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'DriverBlackListReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report,
      props: true
    },
    {
      name: 'DriverCreateBlackList',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'DriverEditBlackList',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
